"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _permission = require("@/utils/permission");
var _enums = require("../activity/enums");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LotteryAssistantRecord',
  directives: {
    // hasPermi: {
    //   inserted(el, binding) {
    //     const { value } = binding
    //     const hasPermission = checkPermi(value)
    //     if (!hasPermission) {
    //       el.parentNode && el.parentNode.removeChild(el)
    //     }
    //   }
    // }
  },
  data: function data() {
    return {
      loading: false,
      total: 0,
      recordList: [],
      dateRange: [],
      queryParams: {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: '',
        redeemCode: '',
        userId: '',
        // 空字符串将被忽略，不作为查询条件
        startTime: '',
        endTime: '',
        temp: new Date().getTime()
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:lottery-assistant:activity:record:list'])) {
      this.getList();
    } else {
      this.$message.error('对不起，您没有访问权限');
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getList: function getList() {
      var _this = this;
      if (!(0, _permission.checkPermi)(['platform:lottery-assistant:activity:record:list'])) {
        this.$message.error('对不起，您没有访问权限');
        return;
      }

      // 确保userId是数字类型
      if (this.queryParams.userId !== '') {
        this.queryParams.userId = parseInt(this.queryParams.userId) || '';
      }
      this.loading = true;
      this.queryParams.temp = new Date().getTime(); // 更新时间戳
      (0, _lotteryAssistant.lotteryRecordListApi)(this.queryParams).then(function (res) {
        _this.recordList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      // 确保userId是数字类型
      if (this.queryParams.userId !== '') {
        this.queryParams.userId = parseInt(this.queryParams.userId) || '';
      }
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.dateRange = [];
      this.queryParams = {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: '',
        redeemCode: '',
        userId: '',
        // 当为空字符串时，后端会忽略此条件
        startTime: '',
        endTime: '',
        temp: new Date().getTime()
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      //选择多少条数据
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    formatter: function formatter(value, key) {
      if (key === 'prizeType') {
        var target = _enums.prizeTypeOptions.find(function (item) {
          return item.value == value;
        });
        return target ? target.label : value;
      }
      return '-';
    },
    handleStatus: function handleStatus(row) {
      var _this2 = this;
      this.$modalSure("\u786E\u5B9A\u8981\u53D1\u653E\u5956\u54C1\"".concat(row.prizeName, "\"\u7ED9\u7528\u6237\u5417\uFF1F")).then(function () {
        var params = {
          recordId: row.recordId,
          prizeStatus: 1
        };
        (0, _lotteryAssistant.lotteryRecordSetStatusApi)(params).then(function (res) {
          _this2.$message.success('发放成功');
          _this2.getList();
        }).catch(function () {
          _this2.$message.error('发放失败');
        });
      }).catch(function () {
        // 取消发放，不做任何操作
      });
    },
    handleDateChange: function handleDateChange(val) {
      if (val) {
        // 开始日期添加起始时间
        this.queryParams.startTime = val[0] + ' 00:00:00';
        // 结束日期加上结束时间，使其包含当天的所有记录
        this.queryParams.endTime = val[1] + ' 23:59:59';
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
    }
  }
};